/*
 * CartHealth Specifications card - variant switching.
 * Managed by the PIM (theme-patches/carthealth-specs). Vanilla JS, no framework.
 *
 * snippets/product-specifications.liquid renders every variant's spec values
 * into a JSON map. The theme fires a bubbling `variant:changed` CustomEvent
 * (detail.variant = the full variant object) from inside the product section
 * whenever the selection changes; we swap the values in place.
 */
(function () {
  'use strict';

  function apply(root, values) {
    var visible = 0;
    var rows = root.querySelectorAll('tr[data-spec]');
    for (var i = 0; i < rows.length; i++) {
      var tr = rows[i];
      if (tr.hasAttribute('data-spec-static')) { visible++; continue; }
      var val = values[tr.getAttribute('data-spec')];
      var cell = tr.querySelector('[data-spec-value]');
      if (val) {
        if (cell) cell.textContent = val;
        tr.hidden = false;
        visible++;
      } else {
        tr.hidden = true;
      }
    }
    root.hidden = visible === 0;
  }

  function init(root) {
    if (root.__chSpecs) return;
    root.__chSpecs = true;

    var data;
    try {
      data = JSON.parse(root.querySelector('[data-ch-specs-json]').textContent);
    } catch (e) {
      return;
    }

    // Only react to variant changes from the product this card belongs to
    // (a page can hold more than one product form, e.g. quick view).
    var scope = root.closest('[data-section-type]') || root.closest('section') || document.body;

    document.addEventListener('variant:changed', function (event) {
      if (!scope.contains(event.target)) return;
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      apply(root, data[String(variant.id)] || {});
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ch-specs]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
